<script setup lang="ts">
import { onMounted, reactive, ref, watch } from 'vue';

export interface PaymentMethod {
  id: string;
  name: string;
  description: string;
  icon: string;
  htmlIcon?: string; // Optional for SVG icons
  selected: boolean;
}

defineProps<{
  modelValue: PaymentMethod | null;
}>();

const $emit = defineEmits<{
  (e: 'update:modelValue', value: PaymentMethod | null): void;
}>();

const payment = ref('shopier');

const paymentMethods = reactive([
  // {
  //   id: 'card',
  //   name: 'Credit Card',
  //   description: 'Pay with your credit card securely.',
  //   icon: 'credit_card',
  //   selected: false,
  // },
  // {
  //   id: 'paypal',
  //   name: 'PayPal',
  //   description: 'Use your PayPal account for quick payments.',
  //   icon: 'paypal',
  //   selected: false,
  // },
  // {
  //   id: 'transfer',
  //   name: 'Bank Transfer',
  //   description: 'Transfer funds directly from your bank account.',
  //   icon: 'bank_transfer',
  //   selected: false,
  // },
  // {
  //   id: 'delivery',
  //   name: 'Cash on Delivery',
  //   description: 'Pay in cash when your order is delivered.',
  //   icon: 'cash_on_delivery',
  //   selected: false,
  // },
  {
    id: 'shopier',
    name: 'Shopier',
    description: 'Shopier ile güvenli ödeme yapın.',
    icon: 'shopier',
    htmlIcon: `
        <svg viewBox="0 0 24 24" width="50px" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M14.5 21.9913V18.5C14.5 17.5654 14.5 17.0981 14.299 16.75C14.1674 16.522 13.978 16.3326 13.75 16.201C13.4019 16 12.9346 16 12 16C11.0654 16 10.5981 16 10.25 16.201C10.022 16.3326 9.83261 16.522 9.70096 16.75C9.5 17.0981 9.5 17.5654 9.5 18.5V21.9913H14.5Z" fill="#96bf48"></path> <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M5.73204 12C4.84126 12 4.05323 11.6239 3.5 11.0329V14C3.5 17.7712 3.5 19.6568 4.67157 20.8284C5.61466 21.7715 7.02043 21.9554 9.5 21.9913H14.5C16.9796 21.9554 18.3853 21.7715 19.3284 20.8284C20.5 19.6568 20.5 17.7712 20.5 14V11.034C19.9468 11.6244 19.1592 12 18.269 12C16.6973 12 15.3814 10.8091 15.225 9.24523L15.152 8.51733C15.3385 10.382 13.8742 12 12.0003 12C10.139 12 8.6819 10.4038 8.84499 8.55511L8.77598 9.24523C8.6196 10.8091 7.30367 12 5.73204 12ZM14.5 18.5V21.9913H9.5V18.5C9.5 17.5654 9.5 17.0981 9.70096 16.75C9.83261 16.522 10.022 16.3326 10.25 16.201C10.5981 16 11.0654 16 12 16C12.9346 16 13.4019 16 13.75 16.201C13.978 16.3326 14.1674 16.522 14.299 16.75C14.5 17.0981 14.5 17.5654 14.5 18.5Z" fill="#96bf48"></path> <path d="M9.4998 2H14.4998L15.1515 8.51737C15.338 10.382 13.8737 12 11.9998 12C10.1259 12 8.6616 10.382 8.84806 8.51737L9.4998 2Z" fill="#96bf48"></path> <path opacity="0.7" d="M3.33024 5.35133C3.50832 4.46093 3.59736 4.01573 3.7784 3.65484C4.15987 2.89439 4.84628 2.33168 5.66677 2.10675C6.05616 2 6.51017 2 7.4182 2H9.50051L8.77598 9.24527C8.6196 10.8091 7.30367 12 5.73204 12C3.80159 12 2.35373 10.2339 2.73232 8.34093L3.33024 5.35133Z" fill="#96bf48"></path> <path opacity="0.7" d="M20.6703 5.35133C20.4922 4.46093 20.4031 4.01573 20.2221 3.65484C19.8406 2.89439 19.1542 2.33168 18.3337 2.10675C17.9443 2 17.4903 2 16.5823 2H14.5L15.2245 9.24527C15.3809 10.8091 16.6968 12 18.2685 12C20.1989 12 21.6468 10.2339 21.2682 8.34093L20.6703 5.35133Z" fill="#96bf48"></path> </g></svg>
    `,
    selected: false,
  },
]);

onMounted(() => {
  updatePaymentMethod();
});

function updatePaymentMethod() {
  const selectedMethod = paymentMethods.find((method) => method.id === payment.value);
  if (selectedMethod) {
    $emit('update:modelValue', selectedMethod);
  } else {
    $emit('update:modelValue', null);
  }
}

watch(payment, (newValue) => {
  const selectedMethod = paymentMethods.find((method) => method.id === newValue);
  if (selectedMethod) {
    selectedMethod.selected = true;
    updatePaymentMethod();
  }
});
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="payment-list--payment-methods">
        <q-card
          v-for="(method, index) in paymentMethods"
          :key="index"
          class="payment-list--payment-method"
          :for="method.id"
          :class="{ selected: method.selected }"
          @click="method.selected = !method.selected"
          v-ripple
        >
          <q-card-section class="payment-list--payment-method_inner">
            <q-radio v-model="payment" checked-icon="task_alt" unchecked-icon="panorama_fish_eye" size="3.25rem" :val="method.id" :id="method.id" />
            <div v-if="method.htmlIcon" class="payment-list--payment-icon" v-html="method.htmlIcon"></div>
            <q-icon v-else class="payment-list--payment-icon" :name="method.icon" size="2rem" />
            <div class="payment-list--payment-details">
              <h5 class="payment-list--payment-title">{{ method.name }}</h5>
              <p class="payment-list--payment-description">{{ method.description }}</p>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>

<style scoped lang="sass">
.payment-list

  &--payment-methods
    display: flex
    flex-direction: column
    gap: 1rem

  &--payment-method
    box-shadow: rgba(0, 0, 0, 0.05) 0 0 0 1px
    background-color: transparent
    border-radius: 8px
    border: 1px solid #ccc

  &--payment-method_inner
    display: flex
    align-items: center
    padding: 1rem .5rem
    flex-grow: 1
    cursor: pointer

  &--payment-icon
    margin-right: .7rem

  &--payment-title
    font-size: 1.2rem
    margin: 0 0 0.5rem 0
    line-height: 1
    font-weight: 600
    letter-spacing: 0.03rem

  &--payment-description
    font-size: 0.9rem
    color: #666
    margin: 0
</style>
